import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Landing from './pages/Landing'
import Projects from './pages/Projects'
import Contact from './pages/Contact'
import About from './pages/About'
import Blog from './pages/Blog'
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element = {<Landing />}/>
        <Route path="/blog" element = {<Blog />}/>
        <Route path="/about" element = {<About />}/>
        <Route path="/contact" element = {<Contact />}/>
        <Route path="/projects" element = {<Projects />}/>
        {/* Add more routes as necessary */}
      </Routes>
    </Router>
  );
}

export default App;